<app-basic-page [pageTitle]="'Simulated Meetings'" [pageDescription]="'Simulated Meetings History'">
  <nz-tabset [(nzSelectedIndex)]="selectedTabIndex">
    <nz-tab nzTitle="Recent">
      <div class="tab-content vertical-large">
        <nz-segmented
          class="fit-content"
          [nzSize]="'large'"
          [nzOptions]="recentOptions"
          (nzValueChange)="handleRecentIndexChange($event)"
        ></nz-segmented>

        <app-session-table [sessionList]="recentSessionList()"></app-session-table>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Group By Scenario">
      <div class="tab-content">
        <div class="vertical-large">
          <app-selectable-session-template-list
            (selectableSessionTemplateListChange)="onSessionTemplateListChange($event)"
          ></app-selectable-session-template-list>

          <app-session-table [sessionList]="sessionTemplateSessionList()"></app-session-table>
        </div>
      </div>
    </nz-tab>
    <!-- <nz-tab nzTitle="Group By Members">
        <div class="tab-content">
          <div class="vertical-large">
            <app-selectable-personal-board-list
              (selectableChange)="onPersonalBoardChange($event)"
            ></app-selectable-personal-board-list>

            <app-session-table [sessionList]="memberSessionList()"></app-session-table>
          </div>
        </div>
      </nz-tab> -->
  </nz-tabset>
</app-basic-page>
